/**
  Copyright (c) 2015, 2018, Oracle and/or its affiliates.
  The Universal Permissive License (UPL), Version 1.0
*/

'use strict';

define('vb/components/mobile-navigation-bar-bottom/loader',[
  'ojs/ojcomposite',
  'text!./view.html',
  './viewModel',
  'text!./component.json',
  'text!./styles.css',
  '../mobile-navigation-item/loader'],
(Composite, view, viewModel, metadata, styles) => {
  const style = document.createElement('style');
  document.querySelector('head').appendChild(style);
  style.appendChild(document.createTextNode(styles));

  Composite.register('oj-ext-mobile-navigation-bar-bottom', {
    view,
    viewModel,
    metadata: JSON.parse(metadata),
  });
});

